/**
 * PendingDraftsBanner
 * ===================
 * Compact banner showing the pending draft count with a single "Review" button
 * that navigates to the bulk review page. `count` is the authoritative total of
 * pending drafts (from the drafts endpoint's `total`), so it matches the sidebar
 * badge rather than being capped by the API fetch limit.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

const PendingDraftsBanner = ({ count = 0 }) => {
  const navigate = useNavigate();

  if (!count || count <= 0) return null;

  return (
    <div className="mb-6 bg-amber-50 border border-amber-200 rounded-xl px-5 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-200 flex items-center justify-center">
          <span className="text-sm font-bold text-amber-800">{count}</span>
        </div>
        <div>
          <p className="text-sm font-medium text-amber-900">
            {count} pending update{count !== 1 ? 's' : ''}
          </p>
          <p className="text-xs text-amber-700">
            Structure entity changes awaiting review
          </p>
        </div>
      </div>
      <button
        onClick={() => navigate('/brain/drafts')}
        className="flex-shrink-0 px-4 py-2 text-sm font-medium text-white bg-amber-600 rounded-lg hover:bg-amber-700 transition-colors shadow-sm"
      >
        Review
      </button>
    </div>
  );
};

export default PendingDraftsBanner;
